<template>
  <div style="text-align:center; padding:20px 0;">
    <div style="width:80px; padding-left:10px; margin:0 auto;">
      <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 85.7 80.2" style="enable-background:new 0 0 85.7 80.2;" xml:space="preserve">
        <path style="fill:#DBDFE5;" d="M60.4,22.9c0.4-2.5,0.2-4.2-0.7-6.1c-2.3-4.8,0.9-9.3,7.6-11.3c6.2-1.8,13.2,1.9,13.7,7.4
          c0.6,6.4-5.8,11.4-12.5,9.9C65.8,22.1,63.2,20.8,60.4,22.9z"/>
        <path style="fill:#B0B9C3;" d="M54.6,54.5c0-2.9,0.1-5.9,0.1-8.8c2.5,3,5,5.9,7.5,8.9C59.7,55.7,57.2,55.7,54.6,54.5z"/>
        <g>
          <path style="fill:#DBDFE5;" d="M62.2,54.5c1.6,3.5,0.4,7.3,0.7,10.9c0.1,1.4,0,2.7,0,4.1c0.9,3.4,0.1,5.3-3.1,6.4c-1.8,0.6-3.7,0.8-5.5,0.8
            c-12.2,0-24.4,0-36.6,0c-2.1,0-4.2-0.2-6.2-1c-3-1.2-3.6-2.8-2.5-6.2c0.5-5-0.9-10.1,0.7-15c2.5-0.4,5-0.3,7.6-0.3
            c3.6-0.3,7,0.1,9,3.8c0.7,1.3,2.3,1.4,3.7,1.4c4,0,8,0.1,12,0c1.2,0,2.8,0,3.4-1.2c1.9-4.1,5.4-4.2,9.1-4.3
            C57,54.4,59.6,54,62.2,54.5z"/>
          <path style="fill:#F4F4F6;" d="M54.6,54.5c-0.9,0.5-1.8,0.9-2.8,0.8c-2.7-0.3-4.6,0.3-5.2,3.3c-0.3,1.6-1.7,2-3.2,1.9c-5,0-10,0-14.9,0
            c-1.2,0-2.6-0.1-2.9-1.2c-1.3-4.5-4.8-4.3-8.3-4.1c-1.9-3.1-0.8-6.4-0.7-9.6C18,40,17,34.3,17.2,28.6c0.2-8.7-0.9-7.7,7.9-7.8
            c8.6,0,17.2,0.1,25.8-0.1c3,0,3.9,1.1,3.9,4c-0.1,7,0,14,0,21C55.8,48.6,56.7,51.6,54.6,54.5z"/>
          <path style="fill:#F6F6F6;" d="M9,69.5c0.1,4.5,0.9,5.8,5.8,5.8c14.1,0.3,28.2,0.2,42.3,0.1c3.7,0,6.1-1.8,5.9-5.9c2.1,1.2,5.9,1.1,5.7,4
            c-0.2,2.8-3.8,3.1-6.3,3.6c-5.8,1.3-11.7,2.1-17.7,2.2c-10.8,0.1-21.6,0.7-32.2-1.5c-2.2-0.4-4.4-1-6.5-1.6
            c-1.2-0.4-2.9-0.8-2.8-2.6c0.1-1.6,1.4-2.2,2.7-2.8C6.8,70.3,7.9,69.9,9,69.5z"/>
          <path style="fill:#B0BAC3;" d="M16.5,45.7c1.5,3.1,0.3,6.4,0.7,9.6c-2.5-0.4-5.2,0.8-7.5-0.8C11.9,51.6,14.2,48.6,16.5,45.7z"/>
          <path style="fill:#DCE0E6;" d="M36.1,25.3c3.1,0,6.2,0,9.4,0c2.7,0,4.2,1,4,4c-0.2,2.2-0.2,4.5,0,6.7c0.3,3.1-1.3,4.1-3.8,4.2
            c-6.6,0.1-13.2,0.1-19.9,0c-2.2,0-3.5-1-3.4-3.4c0.1-2.6,0.1-5.3,0-7.9c-0.2-2.7,1.2-3.6,3.6-3.6C29.4,25.3,32.8,25.3,36.1,25.3z"
            />
          <path style="fill:#E2E5EA;" d="M35.7,47.8c-3.5,0-7,0-10.5,0c-1.1,0-2.5-0.1-2.4-1.7c0.1-1.2,1.3-1.3,2.3-1.3c7,0,14,0,21,0
            c1.1,0,2.6,0.1,2.6,1.4c0,1.2-1.4,1.6-2.6,1.6C42.7,47.8,39.2,47.8,35.7,47.8z"/>
          <path style="fill:#DDE1E6;" d="M35.8,53c-3.5,0-7,0-10.4,0c-0.9,0-2.4,0.5-2.4-0.9c0-1.5,1.5-1.3,2.6-1.3c5.7,0,11.4,0,17.1,0
            c1.1,0,2.2,0,3.4,0c1.1,0,2.8-0.3,2.8,1c0,1.7-1.8,1.2-3,1.2C42.5,53.1,39.1,53,35.8,53z"/>
        </g>
        <circle style="fill:#FEFEFE;" cx="64.5" cy="13.8" r="1.5"/>
        <circle style="fill:#FEFEFE;" cx="70" cy="13.8" r="1.5"/>
        <circle style="fill:#FEFEFE;" cx="75.5" cy="13.8" r="1.5"/>
      </svg>
    </div>
    <div style="color:#727d87;">
      {{message}}
    </div>
  </div>
</template>

<script>
export default {
  name:'empty',
  props: {
    message: {
      type: String,
      default:'没有内容'
    },
  },
  data(){
    return{
    }
  },
}
</script>
<style>
  .st0{fill:#DBDFE5;}
  .st1{fill:#B0B9C3;}
  .st2{fill:#F4F4F6;}
  .st3{fill:#F6F6F6;}
  .st4{fill:#B0BAC3;}
  .st5{fill:#DCE0E6;}
  .st6{fill:#E2E5EA;}
  .st7{fill:#DDE1E6;}
  .st8{fill:#FEFEFE;}
</style>


// WEBPACK FOOTER //
// src/components/states/empty.vue